import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { AppContextProvider } from "./context/AppContext";
import React, { useContext, Suspense, useState, useEffect } from "react";
import SignIn from "./pages/SignIn";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import IndexHome from "./pages/Auth/Home";
import Error from "./pages/Error";
import ForgetPassword from "./pages/ForgetPassword";
import Home from "./pages/Auth/Home";
import MasterFacilitator from "./pages/MasterFacilator";
import CertifiedPractitioner from "./pages/CertifiedPractitioner";
import CertificateMangement from "./pages/CertificateMangement";
import Survey from "./pages/Survey";
import ContentManagerForm from "./pages/Content";
import ViewContent from "./pages/ViewContent";
import Transaction from "./pages/Transaction";
import PricingManagement from "./pages/PricingManagement";
import ViewSurvey from "./pages/ViewSurvey";
import ContentFormPage from "./pages/EditContent";
import EmailTemplate from "./pages/EmailTemplate";
import ViewEmail from "./pages/ViewEmail";
import EmailFormPage from "./pages/EditEmail";
import Codes from "./pages/Codes";
import TQTeamSurveysIndex from "./pages/TQ-Team-Surveys/Index";
import AddSurveysIndex from "./pages/TQ-Team-Surveys/AddSurvey";
import FollowUpSurveyDashboard from "./pages/FollowUpSurveyschaseCredits";
import AddFollowSurveysIndex from "./pages/FollowUpSurveyschaseCredits/AddSurvey";
import TqForLeaderform from "./pages/TqforLeader/tqForLeaderform";
import TqForLeader from "./pages/TqforLeader/index";
import TPSFoundations from "./pages/TPSFoundations/index";
import FollowupForTPSFoundations from "./pages/FollowupforTPSFoundations/index";
import AddNewSurveyForm from "./pages/TPSFoundations/addnewsurveyform";
import AddFollowTpsSurveysIndex from "./pages/FollowupforTPSFoundations/addfollowsurvey";
import LaunchFollowUpSurveyForm from "./pages/Folowupforleader/addlaunchfollowupform";
import FollowupForLeaderform from "./pages/Folowupforleader/index";
window.Buffer = window.Buffer || require("buffer").Buffer;
const ProtectedRoute = ({ element, permissionKey }) => {
  const user = JSON.parse(localStorage.getItem("userProfile")) || {};
  const type = user?.type;
  const permissions = user?.roleId?.permission || [];

  if (type === "Admin") {
    return element;
  }

  const hasPermission = permissions.some(
    (perm) => perm.name === permissionKey && perm.view
  );

  return hasPermission ? element : <Navigate to="/" />;
};

/**
 * App component which wraps the entire app with necessary providers
 * and renders the routes
 *
 * @returns {React.ReactElement} The rendered app
 */

/******  c2642731-3066-4124-a7e7-90f98ee34808  *******/ function App() {
  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 200);
  // }, []);

  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} />
            {/* {loading ? <></> : <AppRoutes />}{" "} */}
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

let publicPaths = ["/login", "/"];

const privateRoutes = (isLoggedIn) => {
  // if (!isLoggedIn) {
  //   if (!publicPaths.includes(window.location.pathname)) {
  //     return (window.location.pathname = "/login");
  //   }
  // }

  return (
    <Route
      path="/"
      element={
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      }
    >
      <Route exact path="/" element={<IndexHome />} />
      <Route exact path="/dashboard" element={<IndexHome />} />
      <Route exact path="/master-facilitator" element={<MasterFacilitator />} />
      <Route exact path="/codes" element={<Codes />} />
      <Route
        exact
        path="/certified-practitioner"
        element={<CertifiedPractitioner />}
      />
      <Route exact path="/survey" element={<Survey />} />
      <Route exact path="/view-survey" element={<ViewSurvey />} />
      <Route exact path="/view-content/:id" element={<ViewContent />} />
      <Route exact path="/view-email/:id" element={<ViewEmail />} />
      <Route
        exact
        path="/certificate-management"
        element={<CertificateMangement />}
      />
      <Route exact path="/pricing-management" element={<PricingManagement />} />
      <Route exact path="/content-manager" element={<ContentManagerForm />} />
      <Route exact path="/email-template" element={<EmailTemplate />} />
      <Route exact path="/transaction" element={<Transaction />} />
      <Route path="/content/edit/:id" element={<ContentFormPage />} />
      <Route path="/email/edit/:id" element={<EmailFormPage />} />
      <Route path="/email/add" element={<EmailFormPage />} />
      <Route path="/tq-team-servey" element={<TQTeamSurveysIndex />} />
      <Route path="/add-surveys-form" element={<AddSurveysIndex />} />
      <Route path="/follow-up-surveys" element={<FollowUpSurveyDashboard />} />
      <Route
        path="/follow-up-surveys-add"
        element={<AddFollowSurveysIndex />}
      />

      <Route path="/tqforleader" element={<TqForLeader />} />
      <Route path="/tqforleaderform" element={<TqForLeaderform />} />
      <Route
        path="/followupforleaderform"
        element={<FollowupForLeaderform />}
      />
      <Route
        path="/add-launch-follow-up-survey"
        element={<LaunchFollowUpSurveyForm />}
      />

      <Route path="/tpsfoundations" element={<TPSFoundations />} />
      <Route path="/add-new-tps-survey" element={<AddNewSurveyForm />} />

      <Route
        path="/followuptpsfoundations"
        element={<FollowupForTPSFoundations />}
      />
      <Route
        path="/add-follow-tps-surveys"
        element={<AddFollowTpsSurveysIndex />}
      />
    </Route>
  );
};

const publicRoutes = (isLoggedIn) => {
  return (
    <>
      {isLoggedIn ? (
        <Route path={"*"} element={<Home />} />
      ) : (
        <>
          <Route path="/login" element={<SignIn />} />
          <Route path="/" element={<SignIn />} />
          <Route path="/reset-password" element={<ForgetPassword />} />
        </>
      )}
    </>
  );
};

const AppRoutes = () => {
  const { isLoggedIn } = useContext(AuthContext);

  return (
    <Routes>
      {publicRoutes(isLoggedIn)}
      {privateRoutes(isLoggedIn)}
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
